module.exports = __webpack_public_path__ + "static/media/logo.705d6b8e.webp";